const Warranty = {
    warrantyProductList: () => 'admin/warranty/claimed-products',
    warrantyProductDetail: (id: string) => `admin/warranty/claimed-products/${id}`,
    approveReject: (id:string) =>`admin/warranty/status/${id}`,
}
export default Warranty